// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"39":"component---src-pages-datenschutz-mdx","219":"component---src-pages-impressum-mdx","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"39":"ef105c8d74d3f3f0b886","219":"fa7374a674554e5b25b9","678":"1a5c7b71cff5a0ecb5a7","883":"23b3d22a0ca3faef543e"}[chunkId] + ".js";
};